<div class="container transparent" fxLayout="column" fxLayoutGap="1em" fxLayoutAlign="center center" style="height: 100%">
  <div class="loader-container">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>
</div>
